// extracted by mini-css-extract-plugin
export var chevronIcon = "_7q-2";
export var teamName = "_7q-1";
export var teamSwitcherButton = "_7q-0";